import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { Router} from '@angular/router';
import { LoginService } from 'app/services/login/login.service';



@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate,CanActivateChild {

  
  IdRolUser : any ;
  clickGuard :any;
  
  constructor(private router:Router,private loginService: LoginService){

  }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      this.clickGuard = this.loginService.clickGuard;
      try {
        this.IdRolUser = JSON.parse(sessionStorage.getItem("UserRol"));
      } catch (e) {
        this.IdRolUser = null;
      }

      if (this.IdRolUser == null || this.IdRolUser == undefined) {
        try {
          const userActive = JSON.parse(sessionStorage.getItem("UserActive"));
          if (userActive && userActive.id_roles != null) {
            this.IdRolUser = userActive.id_roles;
            sessionStorage.setItem('UserRol', JSON.stringify(this.IdRolUser));
          }
        } catch (e) {
          this.IdRolUser = null;
        }
      }

      if (this.IdRolUser == null || this.IdRolUser == undefined) {
        this.router.navigate(['/login']);
        return false;
      }

      if (this.clickGuard) {
        this.loginService.clickGuard = false;
      }
      return true;
    }
    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):  boolean {
      return this.canActivate(route, state);
 }
  }
  

